<div
  [ngClass]="{
    'filter-card m-2': filterBox,
    card: !filterBox && !noteBox
  }"
>
  <div
    *ngIf="showHeader"
    [ngClass]="{
      'filter-header py-1 px-2': filterBox,
      'card-header': !filterBox && !fieldTableBox,
      'pb-1': noteBox,
      filterOpen: showContent === true && filterBox
    }"
  >
    {{ title }}
  </div>
  <div *ngIf="showContent">
    <ng-content></ng-content>
  </div>
</div>
